module.exports = __webpack_public_path__ + "img/logo_recuperi_azul_escura.01319d98.png";